import { AudienceCampaignCreationWizard } from '@bingads-webui-campaign/audience-campaign-creation-wizard';
import { AudienceAdgroupCreationWizard } from '@bingads-webui-campaign/audience-adgroup-creation-wizard';
import { AudienceAdgroupSettingsWizard } from '@bingads-webui-campaign/audience-adgroup-settings-wizard';
import { AudienceAdvancedTargetSettings } from '@bingads-webui-campaign/audience-advanced-target-settings';
import { AudienceTargetInfo } from '@bingads-webui-campaign/audience-target-info';
import { DependencyResolver } from '@bingads-webui-campaign/dependency-resolver';
import {
  Campaign,
  AdGroup,
  ResponsiveAd,
  ShoppingCampaign,
} from '@bingads-webui-campaign/campaign-ui-schemas';

import SharedBudgetView from '@bingads-webui-campaign-legacy/shared-budget/view/shared-budget-switch-editor';
import ShoppingSettingsView from '@bingads-webui-campaign-legacy/shopping-campaign/view/campaign-creation/shopping-settings';
import Budget from '@bingads-webui-campaign-legacy/budget/view/budget';
import BudgetPanel from '@bingads-webui-campaign-legacy/budget/view/budget-panel';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import timeZoneMapper from '@bingads-webui-component-legacy/timezonemapper/index';
import BiddingStrategyView from '@bingads-webui-campaign-legacy/bidding-strategy/view/setting';
import biddingStrategyTypes from '@bingads-webui-campaign-legacy/bidding-strategy/bidding-strategy-type';
import LocationTargetsView from '@bingads-webui-campaign-legacy/location-targets/view/locationTargets';
import AdScheduleView from '@bingads-webui-campaign-legacy/ad-schedule/view/index';
import CopySettings from '@bingads-webui-campaign-legacy/adgroup-create-advanced/view/copy-adgroup-settings';
import * as criterionLoader from '@bingads-webui-campaign-legacy/base-targets/util/criterionLoader';
import UrlEditor from '@bingads-webui-component-legacy/url-input/view/url-input';
import state from '@bingads-webui-component-legacy/state/index';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import Searchbox from '@bingads-webui-component-legacy/searchbox/view/searchbox';
import pgrid from '@bingads-webui-component-legacy/github/modules/projection-grid/module/projection-grid';
import { bingadsGridColumn } from '@bingads-webui-component-legacy/bingads-grid/shared/column';
import pageContext from '@bingads-webui-static-legacy/page-context';
import SuccessDialog from '@bingads-webui-campaign-legacy/campaign-create-advanced/view/success-dialog';
import stateManager from '@bingads-webui-component-legacy/statemanager/campaignStateManager';
import Constants from '@bingads-webui-static-legacy/constants';
import { AimAudienceAssociationView } from '@bingads-webui-campaign-legacy/audience-association/view/aim-component-view';
import UrlOptions from '@bingads-webui-component-legacy/upgraded-url/view/urlOptionsV2';
import urlOptionsTemplate from '@bingads-webui-campaign-legacy/advanced-settings/template/url-options.pug';
import AdvancedSettingsUrlOptions from '@bingads-webui-component-legacy/upgraded-url/view/advancedSettingsUrlOptions';
import AdRotationView from '@bingads-webui-campaign-legacy/advanced-settings/view/ad-rotation';
import BaseExclusionView from '@bingads-webui-campaign-legacy/advanced-settings/view/base-exclusion';
import exclusionRepository from '@bingads-webui-campaign-legacy/advanced-settings/util/exclusion-repository';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import summaryDataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
import config from '@bingads-webui-component-legacy/config/index';
import preferences from '@bingads-webui-component-legacy/preference/service/index';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import ToggleView from '@bingads-webui-component-legacy/toggle/view/index';
import eventDispatcher from '@bingads-webui-component-legacy/event-dispatcher/index';
import * as TestUurl from '@bingads-webui-component-legacy/upgraded-url/service/testUurl';
import {
  targetConstants,
  BaseTargetUpdateView,
  targetTypes,
} from '@bingads-webui-campaign-legacy/base-targets/index';
import ko_schema from '@bingads-webui-component-legacy/ko-schema/index'; // eslint-disable-line
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import CopyCampaignSetting from '@bingads-webui-campaign-legacy/crud-campaign/view/copy-campaign-settings';
import ActionLanguageAdapter from '@bingads-webui-campaign-legacy/adextension-actionlink/view/language-adapter';
import ActionTypeAdapter from '@bingads-webui-campaign-legacy/adextension-actionlink/view/action-type-adapter';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/audience-campaign');

DependencyResolver.set('component/config/index', config);
DependencyResolver.set('component/preference/service/index', preferences);
DependencyResolver.set('campaignui/feature/shared-budget/view/shared-budget-switch-editor', SharedBudgetView);
DependencyResolver.set('campaignui/feature/budget/view/budget', Budget);
DependencyResolver.set('component/js-data-campaign/index', jsdata);
DependencyResolver.set('$/schema!campaign/Campaign', Campaign);
DependencyResolver.set('$/schema!campaign/AdGroup', AdGroup);
DependencyResolver.set('$/schema!campaign/ResponsiveAd', ResponsiveAd);
DependencyResolver.set('@bingads-webui/i18n-amd-loader!campaignui/feature/audience-campaign', i18n);

// Remove this once dependencies in audience-campaign project are moved to use @bingads-webui/i18n-amd-loader
DependencyResolver.set('component/i18n/loader!campaignui/feature/audience-campaign', i18n);

DependencyResolver.set('component/timezonemapper/index', timeZoneMapper);
DependencyResolver.set('campaignui/feature/location-targets/view/locationTargets', LocationTargetsView);
DependencyResolver.set('component/url-input/view/url-input', UrlEditor);
DependencyResolver.set('component/api-errors-campaign/index', i18nErrors);
DependencyResolver.set('component/upgraded-url/view/urlOptionsV2', UrlOptions);
DependencyResolver.set('$/schema!dynamicdb/ShoppingCampaign', ShoppingCampaign);
DependencyResolver.set('campaignui/feature/shopping-campaign/view/campaign-creation/shopping-settings', ShoppingSettingsView);
DependencyResolver.set('campaignui/feature/bidding-strategy/bidding-strategy-type', biddingStrategyTypes);
DependencyResolver.set('campaignui/feature/bidding-strategy/view/setting', BiddingStrategyView);
DependencyResolver.set('campaignui/feature/budget/view/budget-panel', BudgetPanel);
DependencyResolver.set('campaignui/feature/ad-schedule/view/index', AdScheduleView);
DependencyResolver.set('component/state/index', state);
DependencyResolver.set('component/http/channel/odata', odata);
DependencyResolver.set('component/searchbox/view/searchbox', Searchbox);
DependencyResolver.set('component/github/projection-grid', pgrid);
DependencyResolver.set('component/bingads-grid/shared/column', bingadsGridColumn);
DependencyResolver.set('campaignui/feature/base-targets/viewmodel/targetConstants', targetConstants);
DependencyResolver.set('campaignui/feature/base-targets/view/baseUpdate', BaseTargetUpdateView);
DependencyResolver.set('campaignui/feature/base-targets/viewmodel/targetTypes', targetTypes);
DependencyResolver.set('campaignui/feature/bidding-strategy/view/setting', BiddingStrategyView);
DependencyResolver.set('audienceCampaignPageContext', {
  CurrentAccount: pageContext.CurrentAccount,
  CurrentCustomerId: pageContext.CurrentCustomer.Id,
  isFilterCriterionLevelAdGroup: pageContext.Permissions.isFilterCriterionLevelAdGroup,
});
DependencyResolver.set('Constants', Constants);
DependencyResolver.set('campaignui/feature/campaign-create-advanced/view/success-dialog', SuccessDialog);
DependencyResolver.set('component/statemanager/campaignStateManager', stateManager);
DependencyResolver.set('campaignui/feature/adgroup-create-advanced/view/copy-adgroup-settings', CopySettings);
DependencyResolver.set('campaignui/feature/audience/association/view/aim-component-view', AimAudienceAssociationView);
DependencyResolver.set('campaignui/feature/base-targets/util/criterionLoader', criterionLoader);
DependencyResolver.set('component/upgraded-url/view/advancedSettingsUrlOptions', AdvancedSettingsUrlOptions);
DependencyResolver.set('campaignui/feature/advanced-settings/template/url-options', urlOptionsTemplate);
DependencyResolver.set('campaignui/feature/advanced-settings/view/ad-rotation', AdRotationView);
DependencyResolver.set('campaignui/feature/advanced-settings/util/exclusion-repository', exclusionRepository);
DependencyResolver.set('campaignui/feature/advanced-settings/view/base-exclusion', BaseExclusionView);
DependencyResolver.set('component/edm-campaign/index', edmCampaign);
DependencyResolver.set('SummaryDataContextManager', summaryDataContextManager);
DependencyResolver.set('campaignui/feature/instrumentation/index', instrumentation);
DependencyResolver.set('component/toggle/view/index', ToggleView);
DependencyResolver.set('component/event-dispatcher/index', eventDispatcher);
DependencyResolver.set('component/upgraded-url/service/testUurl', TestUurl);
DependencyResolver.set('PageContext', pageContext);
DependencyResolver.set('component/ko-schema/index', ko_schema);
DependencyResolver.set('component/humanize/decimal', decimal);
DependencyResolver.set('crud-campaign/view/copy-campaign-settings', CopyCampaignSetting);
DependencyResolver.set('campaignui/feature/adextension/actionlink/view/language-adapter', ActionLanguageAdapter);
DependencyResolver.set('campaignui/feature/adextension/actionlink/view/action-type-adapter', ActionTypeAdapter);

export {
  AudienceCampaignCreationWizard,
  AudienceAdgroupCreationWizard,
  AudienceAdgroupSettingsWizard,
  AudienceAdvancedTargetSettings,
  AudienceTargetInfo,
};
